import { Box, IconButton, Paper, TextField, Typography } from '@mui/material';
import { Fragment, useEffect, useRef, useState } from 'react';
import SendIcon from '@mui/icons-material/Send';
import { sharedStyles } from '../../utils/Style';
import { createChatId } from './utils';
import { useAiChat } from '../../hooks/useAiChat';
import { UserMessage } from './UserMessage';
import { AssistantMessage } from './AssistantMessage';
import { StatusBubble } from './StatusBubble';

export const AiChatPage = () => {
  const [chatID, setChatID] = useState('');
  const [typedMessage, setTypedMessage] = useState('');

  const scrollRef = useRef<HTMLDivElement | null>(null);

  const { messages, sendMessage, assistantStatus } = useAiChat(chatID);

  useEffect(() => {
    handleNewChat();
  }, []);

  useEffect(() => {
    const el = scrollRef.current;
    if (!el) return;

    setTimeout(() => {
      el.scrollTop = el.scrollHeight;
    }, 200);
  }, [messages, assistantStatus]);

  const handleNewChat = () => {
    setChatID(createChatId());
  };

  const handleSendMessage = () => {
    sendMessage(typedMessage);

    setTypedMessage('');
  };

  return (
    <Box sx={{ ...sharedStyles.pageBody }}>
      <Box
        sx={{
          display: 'flex',
          flexDirection: 'row',
          alignItems: 'center',
          mb: 1.5,
        }}
      >
        <Typography variant='h5' sx={{ ...sharedStyles.pageTitle, my: 'auto' }}>
          NNET AI
        </Typography>
      </Box>

      <Box
        sx={{
          display: 'flex',
          flexDirection: 'column',
          gap: 1.5,
          flexGrow: 1,
          width: '100%',
          maxWidth: 800,
          alignSelf: 'center',
          minHeight: 0,
        }}
      >
        <Box
          ref={scrollRef}
          sx={{
            display: 'flex',
            flexDirection: 'column',
            gap: 2.5,
            flexGrow: 1,
            width: '100%',
            overflowY: 'auto',
            minHeight: 0,
          }}
        >
          {messages.map((message, i) => (
            <Fragment key={i}>
              {message.role === 'user' ? (
                <UserMessage message={message} />
              ) : (
                <AssistantMessage message={message} />
              )}
            </Fragment>
          ))}

          {assistantStatus === 'thinking' && (
            <StatusBubble text='Düşünüyor...' />
          )}

          {assistantStatus === 'running_tool' && (
            <StatusBubble text='İşleniyor...' />
          )}
        </Box>

        <Paper
          sx={{
            p: 1.5,
            display: 'flex',
            flexDirection: 'row',
            gap: 1.5,
            boxSizing: 'border-box',
            alignItems: 'center',
            width: '100%',
          }}
        >
          <TextField
            placeholder='Size nasıl yardımcı olabilirim?'
            size='small'
            fullWidth
            autoFocus
            multiline
            value={typedMessage}
            onChange={(e) => setTypedMessage(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === 'Enter' && !e.shiftKey) {
                e.preventDefault();
                handleSendMessage();
              }
            }}
          />

          <IconButton onClick={handleSendMessage} color='primary' size='small'>
            <SendIcon />
          </IconButton>
        </Paper>
      </Box>
    </Box>
  );
};
